import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/lib/hooks";
import PackageCard from "@/components/PackageCard";
import PageHeader from "@/components/PageHeader";

export default function Packages() {
  const { t } = useLang();
  const { data: packages = [], isLoading } = useContent("/content/packages");

  return (
    <div data-testid="packages-page">
      <PageHeader title={t("packages.title")} subtitle={t("packages.subtitle")} testId="packages-title" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {isLoading ? (
          <p className="text-zinc-500">{t("common.loading")}</p>
        ) : (
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3" data-testid="packages-grid">
            {packages.map((pkg) => (
              <PackageCard key={pkg.id} pkg={pkg} />
            ))}
          </div>
        )}
        <p className="mt-10 text-sm text-zinc-500">{t("packages.note")}</p>
      </div>
    </div>
  );
}
